import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Section, Eyebrow, FadeIn } from "../../components/public/Section";
import { PageHero } from "./About";
import * as Icons from "lucide-react";

export default function Services() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/public/services").then(r => setItems(r.data)); }, []);
  return (
    <>
      <PageHero title="Services" subtitle="From floral mandaps to industrial canteens — same precision, same warmth." image="https://images.unsplash.com/photo-1696940823960-ee5242bddc47?auto=format&fit=crop&w=2000&q=80" />
      <Section>
        <Eyebrow>Where we serve</Eyebrow>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 mt-6">
          {items.map((s, i) => {
            const Icon = Icons[s.icon] || Icons.Award;
            return (
              <FadeIn key={s.id} delay={i * 0.05}>
                <div className="border border-navy-900/15 p-8 hover:border-gold transition group bg-white royal-card relative" data-testid={`service-${s.slug}`}>
                  <Icon size={28} className="text-gold" strokeWidth={1.4} />
                  <div className="serif text-2xl mt-5">{s.title}</div>
                  <div className="text-navy-900/60 text-sm mt-2">{s.tagline}</div>
                  {s.description && <p className="text-navy-900/50 text-sm mt-4 leading-relaxed">{s.description}</p>}
                </div>
              </FadeIn>
            );
          })}
        </div>
      </Section>
    </>
  );
}
